<script setup lang="ts">
import { useAccountStore } from '@/store/account'
import { getImageUrl } from '@/utils'
import { networks } from '@/utils/config'
import { type CaipNetwork, useAppKitNetwork } from '@reown/appkit/vue'
import { useDark } from '@vueuse/core'
import { Popover } from 'primevue'
import { useToast } from 'primevue/usetoast'
import { computed, onMounted, ref } from 'vue'

const accountStore = useAccountStore()

const isDark = useDark()
onMounted(() => {})
const networkData = useAppKitNetwork()
const toast = useToast()

const currentNetworkData = computed(() => accountStore.currentNetworkData)

const op = ref()

function toggle(event: Event) {
  op.value.toggle(event)
}
function switchNetwork(network: CaipNetwork) {
  try {
    networkData.value.switchNetwork(network)
    accountStore.setNetwork(Number(network.id))
    toast.add({
      severity: 'success',
      summary: `Success`,
      detail: `Switch to ${network.name} Successful`,
      life: 3000,
    })
  }
  catch (error) {
    console.error('Failed to switch network:', error)
  }

  op.value.hide()
}
</script>

<template>
  <div class="switch-chain">
    <div
      class="content p2 flex h-[44px] items-center gap-2 rounded-full bg-[#FAF8F6] px-3 lg:border-2 lg:border-black"
      @click="toggle"
    >
      <img
        class="w-3 lg:w-5"
        :src="
          getImageUrl(`token/${currentNetworkData?.nativeCurrency?.name.toLocaleLowerCase()}.svg`)
        "
      />
      <span class="font-medium">{{ currentNetworkData?.title }}</span>
      <i class="pi pi-angle-down"></i>
    </div>

    <Popover ref="op" :pt="{ content: 'p-2' }">
      <div class="flex flex-col gap-4">
        <ul class="m-0 flex list-none flex-col p-0">
          <li
            v-for="network in networks"
            :key="network.name"
            class="flex cursor-pointer items-center gap-2 px-2 py-3 rounded-border hover:bg-emphasis"
            @click="switchNetwork(network as CaipNetwork)"
          >
            <img
              class="h-5 w-5"
              :src="getImageUrl(`token/${network.nativeCurrency.name.toLocaleLowerCase()}.svg`)"
            />
            <span class="p2 font-medium dark:!text-white">{{ network.title }}</span>
          </li>
        </ul>
      </div>
    </Popover>
  </div>
</template>

<style lang="less">
:deep(.p-popover) {
  &::before {
    display: none;
  }
  &::after {
    display: none;
  }
}
</style>
